import "./App.css";

import { Routes, Route,BrowserRouter } from "react-router-dom";

import Marketer from "./Marketer";
import Error from "./Error";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Marketer/>}></Route>
        <Route path="*" element={<Error/>}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
